import React from 'react'
import { Box } from '@mui/material'
import MDEditor from '@uiw/react-md-editor'
import { Root, Element, RootContent } from 'hast'

interface EntityNoteProps {
    entityId: string
    markdown: string
}

export const EntityNote: React.FC<EntityNoteProps> = ({ markdown }) => {
  if (!markdown) {
    return null
  }

  return (
    <Box mt={2}>
      <MDEditor.Markdown 
        source={markdown} 
        //removing link for MD headers
        rehypeRewrite={(node: Root | RootContent, index?: number, parent?: Root | Element) => {
          if (parent && (parent as Element).tagName && /^h[1-6]$/.test((parent as Element).tagName)) {
            const parentElement = parent as Element
            parentElement.children = parentElement.children.filter(
              (child) => !(child.type === "element" && (child as Element).tagName === "a")
            )
          }
        }}
      />
    </Box>
  )
}